import FilterByOrderStatusSelect from '@/components/common/FilterByOrderStatusSelect';
import TableSearchInput from '@/components/common/TableSearchInput';
import { OrderStatus as OrderStatusEnum } from '@/components/order/order.types';
import DeliveryTable from '@/components/orders/tables/delivery-tables/DeliveryTable';
import { useDeliveryTableData, useDeliveryTableFilters } from '@/context/orders/DeliveryTableFilteredData';
import { ListOrdersView } from '@/hooks/orders/useListOrders';
import { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared/constants/shippingOptions';
import { Stack } from '@montugroup/design-system';
import debounce from 'awesome-debounce-promise';
import type { ReactNode } from 'react';

type Props = {
  HeaderActions?: ReactNode;
  children?: ReactNode;
};

function DeliveryTables({ HeaderActions, children }: Props) {
  const { view } = useDeliveryTableData();
  const { filter, setFilter, statusFilters, setStatusFilters } = useDeliveryTableFilters();

  const showStatusFilters = view === ListOrdersView.Open;

  const handleSearch = debounce((value: string) => {
    setFilter(value);
  }, 150);

  return (
    <Stack gap={8}>
      <Stack
        direction={{ sm: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ sm: 'flex-start', md: 'flex-end' }}
        gap={4}
        flexWrap={'wrap'}
      >
        <Stack direction={{ sm: 'column', md: 'row' }} gap={2}>
          <TableSearchInput value={filter} onChange={handleSearch} placeholder="Order ID, Patient ID, Patient" />
          {showStatusFilters && (
            <FilterByOrderStatusSelect
              allowedStatuses={[
                OrderStatusEnum.AwaitingDispensing,
                OrderStatusEnum.IntervalTime,
                OrderStatusEnum.PharmacyOutOfStock,
                OrderStatusEnum.PharmacyPartiallyOutOfStock,
                OrderStatusEnum.UnableToDispense,
              ]}
              selectedStatuses={statusFilters}
              onSelect={setStatusFilters}
            />
          )}
        </Stack>
        {HeaderActions || null}
      </Stack>

      {children}
      {!children && (
        <Stack>
          <DeliveryTable shippingType={DELIVERY_OPTIONS[DELIVERY_OPTION.SameDayAfternoon].name} />
          <DeliveryTable shippingType={DELIVERY_OPTIONS[DELIVERY_OPTION.SameDay].name} />
          <DeliveryTable shippingType={DELIVERY_OPTIONS[DELIVERY_OPTION.ClickAndCollect].name} />
          <DeliveryTable shippingType={DELIVERY_OPTIONS[DELIVERY_OPTION.Standard].name} />
        </Stack>
      )}
    </Stack>
  );
}

export default DeliveryTables;
